/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Urllabel3Inputs */

const en_coinvestments_dataroom_urllabel3 = /** @type {(inputs: Coinvestments_Dataroom_Urllabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

/**
* | output |
* | --- |
* | "URL" |
*
* @param {Coinvestments_Dataroom_Urllabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_urllabel3 = /** @type {((inputs?: Coinvestments_Dataroom_Urllabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Urllabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_urllabel3(inputs)
});
export { coinvestments_dataroom_urllabel3 as "coInvestments_dataRoom_urlLabel" }